import React, { useRef } from "react";
import { FaRegImage } from "react-icons/fa";
import { Form } from "react-bootstrap";
import { Resizable } from "re-resizable";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { htmlToDraftJs } from "../../../editor/utils/htmlToDraftJs";
import { convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import { isUrlValid } from "../../../editor/utils/urlValidation";
import AssetsModal from "../../../core/AssetsModal";

const HeaderSettings = ({ headerData, setHeaderData, isEdited, setIsEdited }) => {
  const urlRef = useRef(null);

  const handleOnImageUrlChange = () => {
    const value = urlRef.current.value;
    setHeaderData((prev) => ({
      ...prev,
      image: {
        ...prev.image,
        url: { value, isValid: isUrlValid(value) },
      },
    }));
    !isEdited && setIsEdited(true);
  };

  const handleOnFileChange = (data) => {
    const src = data.files[0].file;
    setHeaderData((prev) => ({
      ...prev,
      image: { ...prev.image, imgSrc: src },
    }));
    !isEdited && setIsEdited(true);
  };

  const handleOnResize = (e, direction, ref) => {
    const height = ref.clientHeight;
    setHeaderData((prev) => ({
      ...prev,
      image: { ...prev.image, styles: { ...prev.image.styles, height } },
    }));
    !isEdited && setIsEdited(true);
  };

  const handleOnTextChange = (editorState) => {
    const currentContent = editorState.getCurrentContent();
    const markup = draftToHtml(convertToRaw(currentContent));
    const hasText = currentContent.hasText();
    setHeaderData((prev) => ({
      ...prev,
      text: { ...prev.text, markup, hasText },
    }));
    !isEdited && setIsEdited(true);
  };

  return (
    <>
      <Form.Group className="image">
        <h4>Header Image</h4>
        <Form.Group>
          <Form.Label>Link Image: </Form.Label>
          <Form.Control
            type="url"
            placeholder="URL"
            ref={urlRef}
            onChange={handleOnImageUrlChange}
            defaultValue={headerData.image.url?.value || ""}
            style={{
              borderBottomColor: headerData.image.url?.isValid ? "green" : "red",
            }}
          />
        </Form.Group>
        <Form.Group
          className="image-preview"
          style={{ display: headerData.image.imgSrc ? "flex" : "inherit" }}
        >
          {headerData.image.imgSrc ? (
            <Resizable
              className="logo header-footer-resize"
              minHeight={10}
              maxHeight={260}
              enable={{ top: true, bottom: true }}
              size={{
                height: headerData.image.styles?.height || 100,
              }}
              onResize={handleOnResize}
              onMouseDown={(e) => {
                if (e.target.style.cursor && e.target.style.cursor.includes("resize")) {
                  e.preventDefault();
                }
              }}
            >
              <AssetsModal callBackFile={handleOnFileChange} callLocation="Header-image-one">
                <img
                  src={headerData.image.imgSrc}
                  alt="header"
                  style={{
                    height: headerData.image.styles?.height || 100,
                    objectFit: "contain",
                  }}
                />
              </AssetsModal>
            </Resizable>
          ) : (
            <AssetsModal callBackFile={handleOnFileChange} callLocation="Header-image-one">
              <div className="icon-wrapper">
                <FaRegImage size="70px" />
              </div>
            </AssetsModal>
          )}
        </Form.Group>
        <hr />
      </Form.Group>

      <div className="textSettings">
        <h4>Header Text</h4>
        <Editor
          defaultEditorState={htmlToDraftJs(headerData.text.markup)}
          wrapperClassName="wrapper"
          editorClassName="editor"
          onEditorStateChange={handleOnTextChange}
        />
      </div>
      <hr />
    </>
  );
};

export default HeaderSettings;
